import React, {useCallback, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import {Layout, Select, SelectValue} from '@phonectas/unifon-ui-kit';
import {ListItemStyled} from './styled';
import useMrcStore from 'common/stores/mrcStore';

interface NewMrcTemplateSelectProps {
    onChange: (value: SelectValue) => void;
    value?: SelectValue;
}

const NewMrcTemplateSelect: React.FC<NewMrcTemplateSelectProps> = ({
	onChange,
}) => {
	const [t] = useTranslation();
	const {mrcTemplateList, fetchMrcTemplates} = useMrcStore();
	const MRC_TEMPLATES = mrcTemplateList?.templates || [];

	const renderValue = useCallback((selected: SelectValue) => {
		if (!selected) return t('Add new MRC');
		// Find the label for the selected value
		const found = MRC_TEMPLATES.find(opt => opt.oneflow_template_id.toString() === selected);
		return found ? found.description : t('Add new MRC');
	},[t, MRC_TEMPLATES]);
    
	const handleSelectChange = useCallback((
		value: SelectValue,
		_e: React.SyntheticEvent,
		_name: string,
	) => {
		if (typeof value === 'string') {
			if (onChange) {
				onChange(Number(value));
			}
		} else {
			onChange(value);
		}
	}, [onChange]);

	useEffect(() => {
		if (!mrcTemplateList) {
			fetchMrcTemplates();
		}
	}, [mrcTemplateList, fetchMrcTemplates]);

	return (
		<Layout>
			<Select
				renderValue={renderValue}
				fullWidth
				compact
				// usePortal
				onChange={handleSelectChange}
			>
				{MRC_TEMPLATES.map(option => (
					<ListItemStyled
						key={option.id}
						value={option.oneflow_template_id}
						primaryText={option.description}
					/>
				))}
			</Select>
		</Layout>
	);
}

export default NewMrcTemplateSelect;
